import { IListCellUi } from './model';

/**
 * Check that cell have data to display. See template
 *
 * @param cell
 */
export function isCellHaveDataToDisplay(cell: IListCellUi): boolean {
  switch (cell.type) {
    case 'img':
      return Boolean(cell.img || cell.value);
    case 'hidden_button':
    case 'button':
      return Boolean(cell.buttons);
    case 'control':
      return Boolean(cell.config);
    case 'select':
      return true;
    case 'struct':
      return Boolean(cell.structData);
    case 'list':
      return Boolean(cell.listData);
    case 'price':
      return Boolean(cell.priceData);
    case 'link':
      return Boolean(cell.linkData);
    case 'data':
    case 'msg':
      return Boolean(cell.value);
    case 'empty':
      return false;
  }
}
